import React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { Link } from '../Link';
import './styles.scss';

const b = b_.lock('DriversList');

export const DriversList = ({
  background = true,
  className,
  headingTag: Heading = 'h2',
  items = []
}) => (
  <div className={cn(b(), className)}>
    {items.map(({
      name,
      previewText,
      path
    }) => (
      <article
        className={b('item', { background })}
        key={path}
      >
        <Heading className={b('heading')}>
          <Link className={b('link')} to={path}>
            {name}
          </Link>
        </Heading>
        <p className={b('previewText')}>{previewText}</p>
      </article>
    ))}
  </div>
);
